let customer
function vueCustomer() {
    customer = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
            const updateDataLayer = (key) => {
                if (key === 'vehicles') {
                    const vehicleSearch = window.vehicleSearch()
                    vehicleSearch.loadVehicleArray()
                } else if (key === 'currentUserLocation') {
                    const storeSelector = window.storeSelector()
                    storeSelector.refreshStoresUnder100()
                } else if (key === 'history') {
                    const storeHistory = window.storeHistory();
                    storeHistory.addToHistory();
                } else if (key === 'history') {
                    const cartTools = window.cartTools();
                    cartTools.cartLoad()
                }
                //TODO Move nearest store loading to Pinia
            }

            const updateSubmission = (key, submission, updates) => {
                const now = Date.parse(new Date());
                if (localStorage.getItem(key)) {
                    try {
                        const localData = JSON.parse(localStorage.getItem(key));
                        submission[key] = {}
                        submission[key].siteData = localData;
                        submission[key].updated = now;
                        updates[key] = now;
                    } catch (e) {
                        console.error(`Error userData improperly formatted: ${e}`);
                    }
                }
            }

            const updateUserData = async (dataTypeArray, user) => {
                const now = Date.parse(new Date());
                const customerTools = window.customerTools();
                const userData = await customerTools.getCustomer(dataTypeArray, user)
                let updates = localStorage.getItem('updates');
                const entries = Object.entries(userData);
                let submission = {};
                if (!updates) {
                    let updateObject = {};
                    entries.forEach((item) => {
                        if (item?.[1]) {
                            if (item?.[1]?.updated) {
                                updateObject[item[0]] = item[1].updated;
                            } else {
                                updateObject[item[0]] = now;
                            }
                            if (typeof item?.[1]?.jsonValue?.siteData === 'object') {
                                localStorage.setItem(item[0], JSON.stringify(item[1].jsonValue.siteData));
                            }
                            updateDataLayer(item[0]);
                        } else {
                            updateSubmission(item[0], submission, updateObject);
                        }
                    });
                    localStorage.setItem('updates', JSON.stringify(updateObject));
                    localStorage.setItem('sync', now);
                } else {
                    try {
                        let parsedUpdates = JSON.parse(updates);
                        entries.forEach((item) => {
                            if (item?.[1]) {
                                if (item?.[1]?.updated && item?.[1]?.updated > updates?.[item?.[0]]) {
                                    parsedUpdates[item[0]] = item[1].updated;
                                    if (typeof item?.[1]?.jsonValue?.siteData === 'object') {
                                        localStorage.setItem(item[0], JSON.stringify(item[1].jsonValue.siteData));
                                    }
                                    updateDataLayer(item[0]);
                                }
                            } else {
                                updateSubmission(item[0], submission, parsedUpdates)
                            }
                        });
                        localStorage.setItem('updates', JSON.stringify(parsedUpdates));
                        localStorage.setItem('sync', now);
                    } catch (e) {
                        console.error(e);
                    }
                }
                if (Object.keys(submission).length > 0) {
                    customerTools.customerSubmission(submission, user);
                }
            }

            const googleOneTapPrompt = () => {
                const now = Date.parse(new Date());
                const delay = shopifyConfig.reSyncDelay || 15;
                if (!localStorage.getItem('sync') || (Number(localStorage.getItem('sync')) + (delay * 60 * 1000)) < now) {
                    const params = new URLSearchParams(window.location.search);
                    if (params.get('u') || localStorage.getItem(btoa('user'))) {
                        let user
                        if (params.get('u')) {
                            user = params.get('u');
                            localStorage.setItem(btoa('user'), user);
                            const url = new URL(window.location.href);
                            url.search = '';
                            window.history.replaceState({}, document.title, url.toString());
                        } else {
                            user = localStorage.getItem(btoa('user'));
                        }
                        updateUserData(['vehicles', 'cartData', 'currentNearestStore', 'currentUserLocation', 'storesUnder100'], user);
                    } else if (!localStorage.getItem(btoa('user'))) {
                        // A time-based cooldown that just re-asks later isn't
                        // what's wanted here. Show the signed-out prompt at
                        // most once per landing (sessionStorage - cleared at
                        // the end of the browser session, so a genuinely new
                        // visit can prompt again), and the moment the visitor
                        // actively dismisses it without signing in, stop
                        // asking altogether (localStorage - permanent,
                        // survives across sessions).
                        if (sessionStorage.getItem('oneTapPromptedThisSession')) return;
                        if (localStorage.getItem('oneTapRefused')) return;
                        sessionStorage.setItem('oneTapPromptedThisSession', '1');
                        window.onload = function () {
                            google.accounts.id.initialize({
                                client_id: shopifyConfig.gci,
                                callback: custConfirm,
                                ux_mode: 'popup',
                                login_uri: `https://shopify.com/authentication/${shopifyConfig.shopId}/oauth/authorize`,
                                itp_support: true,
                                auto_select: true
                            });
                            // Only an ACTIVE dismissal (closed/tapped away without
                            // signing in) counts as a refusal - not "couldn't be
                            // displayed at all" (blocked cookies, unsupported
                            // browser, etc.), which isn't the visitor saying no.
                            const handlePromptMoment = (notification) => {
                                const skippedReason = typeof notification?.getSkippedReason === 'function' ? notification.getSkippedReason() : null;
                                const dismissedReason = typeof notification?.getDismissedReason === 'function' ? notification.getDismissedReason() : null;
                                const wasActivelyRefused =
                                    (notification?.isSkippedMoment?.() && (skippedReason === 'user_cancel' || skippedReason === 'tap_outside')) ||
                                    (notification?.isDismissedMoment?.() && dismissedReason === 'cancel_called');
                                if (wasActivelyRefused) localStorage.setItem('oneTapRefused', '1');
                            };
                            // The agent chat is a native <dialog> shown via showModal(), which
                            // renders in the browser's top layer above the One Tap prompt. If it's
                            // open, prompt() would just render hidden underneath it and then pop
                            // into view the instant the dialog closes - so wait for that close
                            // instead of calling prompt() into a dialog that's covering it.
                            const agentDialog = document.querySelector('.agent-overlay__dialog');
                            if (agentDialog?.open) {
                                agentDialog.addEventListener('close', () => google.accounts.id.prompt(handlePromptMoment), { once: true });
                            } else {
                                google.accounts.id.prompt(handlePromptMoment);
                            }
                        }
                    }
                }
            }

            Vue.onMounted(() => {
                googleOneTapPrompt()
            })
        }
    })
    customer.use(window.VueAppGlobals.pinia);
    customer.mount('#customer');
}

if (window.Vue && window.Pinia) {
    vueCustomer()
} else {
    window.addEventListener('vue-ready', vueCustomer);
}
